const PDF = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M19.4 2.01a2 2 0 0 1 1.796 1.989v16.003l-.01.204A2 2 0 0 1 19.4 21.99l-.204.01H6.209l-.204-.01a2 2 0 0 1-1.785-1.785l-.01-.204v-2.046H2.987v-7.01h1.221V4a2 2 0 0 1 1.796-1.99L6.21 2h12.987l.204.01ZM6.21 3.498a.5.5 0 0 0-.5.5v6.948h10.168v7.01H5.71V20a.5.5 0 0 0 .5.5h12.987a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H6.209ZM5.991 15.87h.551v-.933h.493c.54 0 .955-.422.956-.952a.945.945 0 0 0-.956-.953H5.992v2.838Zm2.36 0h1.111c.772 0 1.348-.621 1.348-1.42 0-.798-.576-1.418-1.348-1.418H8.351v2.838Zm2.85 0h.552v-1.095h1.088v-.535h-1.088v-.673h1.12v-.535h-1.671v2.838Zm-1.739-2.303c.484 0 .82.36.82.884 0 .522-.336.883-.82.883h-.56v-1.767h.56Zm-2.427-.013c.235 0 .408.184.408.43 0 .244-.173.43-.408.43h-.493v-.86h.493Z"
        />
    </svg>
);

export default PDF;
